import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ServiceGalleries from "../components/ServiceGalleries";

const ServiceGalleryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Service' />

        {/* GalleryLayer */}
        <ServiceGalleries />
      </MasterLayout>
    </>
  );
};

export default ServiceGalleryPage;
